import { action, observable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../commonv3/api/RemoteResourceV3';
import { SubmissionEvaluationResultApis } from '../../../apis/submissionEvaluationResult';
import { ExamPracticalSectionSubmissionToken } from '../../../../commonv3/types/courseExams';

export class SubmissionEvaluationResultState {
    @observable evaluationResult = RemoteResourceV3.loading();
    @observable submissionToken: ExamPracticalSectionSubmissionToken = null;

    @action.bound
    async init(submissionToken: ExamPracticalSectionSubmissionToken) {
        this.submissionToken = submissionToken;
        await this.reload();
    }

    async reload() {
        await updateRemoteResourceV3(
            this.evaluationResult,
            (v) => (this.evaluationResult = v),
            () => SubmissionEvaluationResultApis.show(this.submissionToken)
        );
    }
}
